<ng-container *ngIf="detail">

  <span class="tag tooltip-min tooltip--nowrap tag--active tag--not-clickable mt-5 mr-10"
        *ngIf="detail.ssEU===false && detail.ssNonEU===false && detail.ssRuskyVliv===false"
        [tooltip]="detail.ssDataTimestamp ? 'stav k ' + (detail.ssDataTimestamp | date) : null"
        position="center">
    Ověřeno v sankčních seznamech
  </span>

  <ng-container *ngIf="isDisputed">
    <span *ngFor="let tag of activeTags"
          class="tag tooltip-min tooltip--nowrap tag--active tag--not-clickable mt-5 mr-10"
          [tooltip]="detail.ssDataTimestamp ? 'stav k ' + (detail.ssDataTimestamp | date) : null"
          position="center">
      {{ tag.toUpperCase() }} - Uvedení v seznamu je zpochybněno ({{ sourceDisputed.toUpperCase() }})
    </span>
  </ng-container>

  <ng-container *ngIf="!isDisputed">
    <span *ngFor="let label of activeTags"
          class="tag tooltip-min tooltip--nowrap tag--danger tag--not-clickable is-uppercase mt-5 mr-10"
          [tooltip]="detail.ssDataTimestamp ? 'stav k ' + (detail.ssDataTimestamp | date) : null"
          position="center">
      {{ label }}
    </span>
  </ng-container>

  <ng-template #sanctionDetailTemplate>
    <div *ngFor="let item of sanctionDetails; let i = index" [class.mt-5]="i > 0">
      {{ item.label }}
      <div class="ss-description" [innerHTML]="item.value"></div>
    </div>
  </ng-template>
  <span *ngIf="sanctionDetails.length > 0"
        class="ss-info-icon-vertical-align"
        [tooltip]="sanctionDetailTemplate"
        [activeContent]="true"
        position="center">
    <i class="fa fa-info-circle ss-info-icon"></i>
  </span>

</ng-container>
